import { signOut } from '@/hooks/useAuth';

interface TopBarProps {
  title: string;
  subtitle?: string;
  sidebarCollapsed?: boolean;
  action?: React.ReactNode;
}

export default function TopBar({ action }: TopBarProps) {
  return (
    <header className="fixed top-0 left-0 right-0 md:left-auto h-14 md:h-16 z-30 bg-dark-bg/95 backdrop-blur-sm border-b border-dark-border flex items-center justify-between px-4 md:px-6">
      {/* Lado esquerdo — espaço espelho para centralizar */}
      <div className="flex-1 flex items-center">
        <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-neon/10 border border-neon/20 md:hidden">
          <i className="ri-store-3-fill text-neon text-sm"></i>
        </div>
      </div>

      {/* Centro — logo */}
      <div className="flex items-center justify-center">
        <span
          className="uppercase text-white leading-none text-base md:text-xl"
          style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 800, letterSpacing: '0.08em' }}
        >
          PIOT<span className="text-neon">FIT</span>
        </span>
      </div>

      {/* Lado direito — ações */}
      <div className="flex-1 flex items-center justify-end gap-2">
        {action && <div>{action}</div>}
        <button
          onClick={() => signOut()}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-dark-muted hover:text-red-400 hover:bg-red-500/10 transition-all cursor-pointer whitespace-nowrap text-xs font-medium"
          title="Sair"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-logout-box-r-line text-sm"></i>
          </div>
          <span className="hidden sm:inline">Sair</span>
        </button>
      </div>
    </header>
  );
}
